import { appHosts } from '../appHosts';
import type { MFNamesKeys } from '../MFNames';

export function isHost(mfName: MFNamesKeys) {
	return mfName in appHosts;
}
